import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ProfileService } from "../services/profile.service";
import { IProfileEntity } from "../domains/profile/interfaces/profile-controls.interface";

export const getProfileResolver: ResolveFn<IProfileEntity> = () => {
  const profileService = inject(ProfileService);
  return profileService.getProfile();
};
